export default __webpack_public_path__ + "static/media/ApplePayMark.e5b593c9.svg";